module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newprovider":"New provider","nameProvider":"Name of the provider","urlProvider":"Configuration URL of the provider","urlnotvalid":"This url is not valid"},"fr":{"newprovider":"Nouveau provider","nameProvider":"Nom du provider","urlProvider":"URL de configuration","urlnotvalid":"Cette url n\u0027est pas valide"}}')
  delete Component.options._Ctor
}
